export default __webpack_public_path__ + "static/media/glrc.content.videos.d0ca5c8f.jpg";